import { render } from "./MainCard.vue?vue&type=template&id=ca5e8790&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"

import "./MainCard.vue?vue&type=style&index=0&id=ca5e8790&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5e8790"]])

export default __exports__